import React, { Component } from 'react'

// subComponent
import ListObjects from './list_objects'
import HeadBar from './headbar'
import ModalConfirmDelete from './modal_confirm_delete'
import ModalObjectInfo from './modal_objects_info'
import Paginate from './paginate'
import { Button } from 'antd'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/component_select_object/actions'

// props: : khi select xong hoac huy thi se tra ve call back
// onSuccess(selectList): khi nguoi dung lua chon
// onCancel(): khi nguoi dung khong chon
// initObject: khoi tao select
class ObjectsScreen extends Component {
    componentDidMount() {
        console.log('selectobject didmount')
        this.props.loadListObject({ status: 0 })

        if (Array.isArray(this.props.initObject)) {
            this.props.updateSelectedObject(this.props.initObject)
        } else {
            this.props.updateSelectedObject([])
        }

    }

    componentWillReceiveProps = nextProps => {
        if (
            Array.isArray(nextProps.initObject) &&
            nextProps.initObject !== this.props.initObject
        ) {
            this.props.updateSelectedObject(nextProps.initObject)
            this.props.loadListObject({})
        }
    }

    _onClickOk = () => {
        const { selected_object } = this.props
        this.props.onSuccess(selected_object)
        this.props.updateTextSearch('')
        this.props.searchObject()
        this.props.updateSelectedObject([])

    }

    _onCancel = () => {
        this.props.onCancel()

    }


    render() {
        const { height, selected_object_length, total } = this.props

        return (
            <div className="ComponentSelectObject">
                <div style={{ minHeight: height - 200 }}>
                    <HeadBar />
                    <div style={{ color: 'black', marginTop: 10 }}>
                        Có {selected_object_length} đối tượng đã được chọn
                    </div>

                    <ListObjects />

                    <div className="ButtonObjectInTask">
                        {selected_object_length > 0 && total > 0 && <Button
                            style={{ marginRight: 15 }}
                            type="primary"
                            onClick={this._onClickOk}
                        >
                            {!this.props.disableCancelBtn ? 'Chọn đối tượng' : 'Xuất ra file'}
                        </Button>}

                        {!this.props.disableCancelBtn && <Button type="danger" onClick={this._onCancel}>
                            Huỷ
                        </Button>}
                    </div>

                    <Paginate />
                    <ModalConfirmDelete />
                    <ModalObjectInfo />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
        selected_object: state.component_select_object.selected_object,
        selected_object_length:
            state.component_select_object.selected_object.length,
        total: state.component_select_object.total,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListObject: params => {
            dispatch(objectActions.action.loadListObject(params))
        },
        updateSelectedObject: objects => {
            dispatch(objectActions.action.updateSelectedObject(objects))
        },
        updateTextSearch: textSearch => {
            dispatch(objectActions.action.updateTextSearch(textSearch))
        },
        searchObject: () => {
            dispatch(objectActions.action.searchObject())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ObjectsScreen)
